const mutations = {
    SET_API_KEYS: (state, payload) => state.apiKeys = payload,
    SET_DELETE_API_KEY_LOADING: (state, payload) => state.deleteApiKeyLoading = payload,
    SET_GENERATE_API_KEY_LOADING: (state, payload) => state.generateApiKeyLoading = payload,
    SET_GET_API_KEYS_LOADING: (state, payload) => state.getApiKeysLoading = payload,
    PUSH_API_KEY: (state, payload) => {
        if(!state.apiKeys) {
            state.apiKeys = [];
        }
        state.apiKeys.push(payload)
    },
    SET_TWILIO_CHANNEL_INFO: (state, payload) => state.twilioChannelInfo = payload,
    SET_TWILIO_CHANNEL_INFO_LOADING: (state, payload) => state.twilioChannelInfoLoading = payload,
    SET_UPDATE_TWILIO_CHANNEL_INFO_LOADING: (state, payload) => state.updateTwilioChannelInfoLoading = payload,

    SET_INCOMING_EVENT_CHANNEL_INFO: (state, payload) => state.incomingEventChannelInfo = payload,
    SET_INCOMING_EVENT_CHANNEL_INFO_LOADING: (state, payload) => state.incomingEventChannelInfoLoading = payload,
    SET_UPDATE_INCOMING_EVENT_CHANNEL_INFO_LOADING: (state, payload) => state.updateIncomingEventChannelInfoLoading = payload,

    SET_PODIUM_CHANNEL_INFO: (state, payload) => state.podiumChannelInfo = payload,
    SET_PODIUM_CHANNEL_INFO_LOADING: (state, payload) => state.podiumChannelInfoLoading = payload,
    SET_UPDATE_PODIUM_CHANNEL_INFO_LOADING: (state, payload) => state.updatePodiumChannelInfoLoading = payload,
};

export default mutations;
